/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderItemDto
 */
export interface OrderItemDto {
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    ean?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    quantity?: number;
}

/**
 * Check if a given object implements the OrderItemDto interface.
 */
export function instanceOfOrderItemDto(value: object): value is OrderItemDto {
    return true;
}

export function OrderItemDtoFromJSON(json: any): OrderItemDto {
    return OrderItemDtoFromJSONTyped(json, false);
}

export function OrderItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ean': json['ean'] == null ? undefined : json['ean'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function OrderItemDtoToJSON(json: any): OrderItemDto {
    return OrderItemDtoToJSONTyped(json, false);
}

export function OrderItemDtoToJSONTyped(value?: OrderItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ean': value['ean'],
        'quantity': value['quantity'],
    };
}

